import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';

import type { AdminHubSpotCompanySummary } from './useAdminCompanyExternalConnections';

/**
 * Likely HubSpot matches for a company, worked out from the email domains of
 * its own members. Saves typing in the common case.
 */
export function useSuggestAdminHubSpotCompanies(
  companyId: number,
  enabled: boolean
) {
  const key = enabled
    ? `admin/companies/${companyId}/external-connections/hubspot/suggestions`
    : null;

  const { data, error, isLoading } = useSWR<AdminHubSpotCompanySummary[]>(
    key,
    key ? SWRFetcher({ method: 'GET' }, undefined) : null
  );

  return { suggestions: data ?? [], error, isLoading: !!isLoading };
}
